import React, { useState, useEffect } from 'react';
import axiosInstance from '../lib/axiosInstance';
import { useNavigate } from 'react-router-dom';

function MySettlements() {
    const navigate = useNavigate();
    const [settlements, setSettlements] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSettlements = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get('/brand/settlements');
            if (response.data?.success) {
                setSettlements(response.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching settlements:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettlements();
    }, []);

    const getStatusBadge = (status) => {
        const config = {
            unpaid: { bg: '#fee2e2', text: '#991b1b', label: 'Unpaid' },
            partially_paid: { bg: '#fef3c7', text: '#92400e', label: 'Partial' },
            paid: { bg: '#d1fae5', text: '#065f46', label: 'Settled' },
            carried_forward: { bg: '#dbeafe', text: '#1e40af', label: 'C/F' }
        };
        const s = config[status] || { bg: '#f3f4f6', text: '#374151', label: status };
        return (
            <span style={{ 
                padding: '4px 10px', 
                borderRadius: 'full', 
                fontSize: '12px', 
                fontWeight: 600, 
                backgroundColor: s.bg, 
                color: s.text,
                borderRadius: '20px'
            }}>
                {s.label}
            </span>
        );
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '32px' }}>
                <h1 className="lux-heading" style={{ fontSize: '28px', marginBottom: '8px' }}>My Settlements</h1>
                <p style={{ color: 'var(--muted)', fontSize: '16px' }}>View your monthly earnings and payment status</p>
            </div>

            <div style={{ 
                background: 'var(--surface)', 
                borderRadius: '16px', 
                border: '1px solid var(--border)', 
                overflow: 'hidden',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: 'rgba(0,0,0,0.02)', borderBottom: '1px solid var(--border)' }}>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)' }}>Period</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'right' }}>Total Credit</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'right' }}>Total Debit</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'right' }}>Net Payable</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'right' }}>Paid</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'center' }}>Status</th>
                            <th style={{ padding: '16px', fontSize: '14px', fontWeight: 600, color: 'var(--muted)', textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: 'var(--muted)' }}>Loading records...</td></tr>
                        ) : settlements.length === 0 ? (
                            <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: 'var(--muted)' }}>No settlement records found.</td></tr>
                        ) : (
                            settlements.map((s) => (
                                <tr key={s.id} style={{ borderBottom: '1px solid var(--border)' }}>
                                    <td style={{ padding: '16px', fontWeight: 600 }}>{s.settlementMonth}</td>
                                    <td style={{ padding: '16px', textAlign: 'right' }}>₹{Number(s.totalCredits).toLocaleString('en-IN')}</td>
                                    <td style={{ padding: '16px', textAlign: 'right', color: '#ef4444' }}>₹{Number(s.totalDebits).toLocaleString('en-IN')}</td>
                                    <td style={{ padding: '16px', textAlign: 'right', fontWeight: 700, fontSize: '16px' }}>₹{Number(s.netPayable).toLocaleString('en-IN')}</td>
                                    <td style={{ padding: '16px', textAlign: 'right', color: '#10b981', fontWeight: 600 }}>₹{Number(s.amountPaid).toLocaleString('en-IN')}</td>
                                    <td style={{ padding: '16px', textAlign: 'center' }}>{getStatusBadge(s.status)}</td>
                                    <td style={{ padding: '16px', textAlign: 'center' }}>
                                        <button 
                                            onClick={() => navigate(`/settlements/${s.brandID}/${s.settlementMonth}`)}
                                            style={{ 
                                                background: 'transparent', 
                                                border: '1px solid var(--border)', 
                                                color: 'var(--text)', 
                                                padding: '6px 12px', 
                                                borderRadius: '6px', 
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: 500
                                            }}
                                        >
                                            View Statement
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default MySettlements;
